export type Region = 'cn' | 'intl';

/**
 * 地区识别:浏览器语言为中文(zh)或时区属于中国大陆/港澳台 → 中国区(cn)。
 * 用于 Pro 订阅的地区差异化定价,前端据此展示价格并把 region 传给 checkout。
 */
export const detectRegion = (): Region => {
  const language = (navigator.language || '').toLowerCase();
  const isZhLanguage = language.startsWith('zh');

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  const isCnTimeZone = /^Asia\/(Shanghai|Chongqing|Harbin|Urumqi|Macau|Hong_Kong|Taipei)/.test(
    timeZone
  );

  return isZhLanguage || isCnTimeZone ? 'cn' : 'intl';
};
